module.exports = __webpack_public_path__ + "static/media/loaderGif.08453fbc.gif";